import { useEffect } from 'react';
import {
  PCLIVE247_ANDROID_APP,
  PCLIVE247_IOS_APP
} from '../../screens/pages/dashboard/contents/seller/manage-cards/constants';

const useAppRedirect = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const androidLink = PCLIVE247_ANDROID_APP;
    const iosLink = PCLIVE247_IOS_APP;

    if (/android/i.test(userAgent)) {
      window.location.href = androidLink;
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      window.location.href = iosLink;
    }
  }, []);
};

export default useAppRedirect;
